import React, {createContext, useContext} from 'react';

const ValidatorContext = createContext();

export const useValidatorContext = () => useContext(ValidatorContext);

export const ValidatorProvider = ({children}) => {
  // const items = children;
  const getValidators = function (item) {
    let validators = [];
    const children = React.Children.toArray(item.props.children);
    for (const child of children) {
      if (child.type && (child.type.displayName === "Validator" || child.type.name === "Validator")) {
        const {state, rules, setErrorMessage} = child.props;
        validators.push({state, rules, setErrorMessage});
      }
      if (child && child.props && child.props.children) {
        const childValidators = getValidators(child);
        validators = validators.concat(childValidators); // Concatenate child validators to the array
      }
    }
    return validators;
  };

  const validatorGetter = function () {
    return getValidators(children);
  };

  ValidatorProvider.validatorGetter = validatorGetter;


  return (
    <ValidatorContext.Provider value={children}>
      {children}
    </ValidatorContext.Provider>
  );
};

ValidatorProvider.getValidatorComponents = function () {
  return ValidatorProvider.validatorGetter();
};

